import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconUnpin2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconUnpin2"><Path d="M7 4.7793V4.77246L17.6367 16H17.5977L20.7266 19.3135L19.2734 20.6865L14.8477 16H13V20L12 22L11 20V16H4V15C4 12.4732 5.17366 10.2224 7 8.75781L7.58691 8.3125L2.27344 2.68652L3.72656 1.31348L7 4.7793Z" fill="currentColor"/><Path d="M17 8.75781C18.8263 10.2224 20 12.4732 20 15V15.5879L7.12695 2H17V8.75781Z" fill="currentColor"/></CentralIconBase>;
});

export default IconUnpin2;
